import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Card, Button } from "react-bootstrap";

function Wild() {
  let navigate = useNavigate();
  return (
    <Container className="mt-3 mb-3">
      <Row>
        <Col>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Card style={{ width: "18rem" }}>
              <Card.Img variant="top" alt="이미지" src="/yeongyeong/main.jpg" />
              <Card.Body>
                <Card.Title>연경 도약대</Card.Title>
                <Card.Text style={{ height: "10rem" }}>
                  연경동에 위치한, 대구에서 가장 유명한 자연 암벽. 다양한
                  난이도의 문제들이 초보자와 상급자를 가리지 않고 품어주고있다.
                </Card.Text>
                <Button
                  onClick={() => {
                    navigate("/wild/yeongyeong");
                  }}
                  variant="primary">
                  톺아보기
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Card style={{ width: "18rem" }}>
              <Card.Img variant="top" alt="이미지" src="/yuhak/main.jpg" />
              <Card.Body>
                <Card.Title>유학산</Card.Title>
                <Card.Text style={{ height: "10rem" }}>
                  칠곡에 위치한 산기슭의 자연암벽. 둥지바위와 학바위로 나뉘어져
                  있으며 최대 2피치 까지의 코스들이 있어 초보자들이 멀티피치
                  연습을 하기 좋다.
                </Card.Text>
                <Button
                  onClick={() => {
                    navigate("/wild/yuhak");
                  }}
                  variant="primary">
                  톺아보기
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Wild;
